__turbopack_context__.v({
  "clearBtn": "TeamsToolbar-module-scss-module__dSOCYq__clearBtn",
  "count": "TeamsToolbar-module-scss-module__dSOCYq__count",
  "filterBtn": "TeamsToolbar-module-scss-module__dSOCYq__filterBtn",
  "left": "TeamsToolbar-module-scss-module__dSOCYq__left",
  "right": "TeamsToolbar-module-scss-module__dSOCYq__right",
  "searchBtn": "TeamsToolbar-module-scss-module__dSOCYq__searchBtn",
  "searchContainer": "TeamsToolbar-module-scss-module__dSOCYq__searchContainer",
  "searchForm": "TeamsToolbar-module-scss-module__dSOCYq__searchForm",
  "searchInput": "TeamsToolbar-module-scss-module__dSOCYq__searchInput",
  "searchOptions": "TeamsToolbar-module-scss-module__dSOCYq__searchOptions",
  "title": "TeamsToolbar-module-scss-module__dSOCYq__title",
  "titleContainer": "TeamsToolbar-module-scss-module__dSOCYq__titleContainer",
  "toolbar": "TeamsToolbar-module-scss-module__dSOCYq__toolbar",
});
